import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import * as appActions from "src/actions/appActions";
import getServiceFromUrl from "src/utils/getServiceFromUrl";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 60,
  },
  contentError: {
    backgroundColor: "#f44336",
  },
  contentSuccess: {
    backgroundColor: "green",
  },
  content: {
    backgroundColor: "transparent",
  },
}));

const SnackBar = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const service = getServiceFromUrl();
  const toast =
    service == "OnlineCheckin"
      ? useSelector((state) => state.checkin.toast)
      : useSelector((state) => state.app.toast);

  function handleClose() {
    dispatch(appActions.deleteToast());
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      autoHideDuration={toast?.type == "failError" ? null : 6000}
      onClose={() => handleClose()}
      className={classes.root}
      open={toast?.message ? true : false}
    >
      <SnackbarContent
        aria-describedby="message-id2"
        className={
          (toast.type === "failError" && classes.contentError) ||
          (toast.type === "error" && classes.contentError) ||
          (toast.type === "success" && classes.contentSuccess) ||
          (toast.type === "" && classes.content)
        }
        action={
          <>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
        message={
          <span id="message-id2">
            {toast.message && typeof toast.message === "string" ? (
              <div style={{ whiteSpace: "pre-wrap" }}>{toast.message}</div>
            ) : (
              <div style={{ whiteSpace: "pre-wrap" }}>Some error occured</div>
            )}
          </span>
        }
      />
    </Snackbar>
  );
};

export default SnackBar;
